module.exports = __webpack_public_path__ + "img/collection-weddingRingsRedgold@2x.29d9bca.webp";